import { render, staticRenderFns } from "./VideoUpload.vue?vue&type=template&id=0e63f9d5&scoped=true&"
import script from "./VideoUpload.vue?vue&type=script&lang=js&"
export * from "./VideoUpload.vue?vue&type=script&lang=js&"
import style0 from "./VideoUpload.vue?vue&type=style&index=0&id=0e63f9d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e63f9d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e63f9d5')) {
      api.createRecord('0e63f9d5', component.options)
    } else {
      api.reload('0e63f9d5', component.options)
    }
    module.hot.accept("./VideoUpload.vue?vue&type=template&id=0e63f9d5&scoped=true&", function () {
      api.rerender('0e63f9d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/publishGoods/components/VideoUpload.vue"
export default component.exports